<div class="adx-lib-widget-add-wrapper">
    <p>{{ 'STREAMING.AHOY_VIDEO.WIDGET.ADD.DESCRIPTION' | translate }}</p>
</div>
